// @ts-nocheck
import { Table } from "@shared/antd/table";
import { Modal } from "@shared/antd/modal";
import { Icon } from "@shared/antd/icon";
import React from "react";
import { TsadvUser } from "../../../../cuba/entities/base/tsadv$UserExt";
import { observer } from "mobx-react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { CustomSelectedActors } from "../modal/StartBprocModal";

type CandidatesProps = {
  candidates: TsadvUser[] | null;
  isShortName?: boolean;
  currentTaskCode?: string;

  customSelectedActors?: CustomSelectedActors[];
  changeCustomSelectedActors?: (
    currentTaskCode: string,
    selectedActors: TsadvUser[],
  ) => void;

  isCanBeSelected?: boolean;
} & WrappedComponentProps &
  RouteComponentProps;

type CandidatesState = {
  visible: boolean;
  selectedRowKeys: string[];
};

@observer
class Candidate extends React.Component<CandidatesProps, CandidatesState> {
  state: CandidatesState = {
    visible: false,
    selectedRowKeys: [],
  };

  componentDidMount() {
    this.syncSelectionFromProps();
  }

  componentDidUpdate(prevProps: CandidatesProps) {
    if (
      prevProps.customSelectedActors !== this.props.customSelectedActors ||
      prevProps.currentTaskCode !== this.props.currentTaskCode
    ) {
      this.syncSelectionFromProps();
    }
  }

  /** Синхронизируем выбранные элементы из props */
  syncSelectionFromProps = () => {
    const { currentTaskCode, customSelectedActors } = this.props;
    const current = customSelectedActors?.find(
      a => a.currentTaskCode === currentTaskCode,
    );
    const selectedRowKeys = current?.selectedApprovers.map(u => u.id) || [];
    this.setState({ selectedRowKeys });
  };

  openModal = () => {
    this.syncSelectionFromProps();
    this.setState({ visible: true });
  };

  closeModal = () => {
    this.setState({ visible: false });
  };

  handleOk = () => {
    const {
      candidates,
      changeCustomSelectedActors,
      currentTaskCode,
      isCanBeSelected,
    } = this.props;
    const { selectedRowKeys } = this.state;

    if (!isCanBeSelected) {
      this.closeModal();
      return;
    }

    const selected =
      candidates?.filter(c => selectedRowKeys.includes(c.id)) || [];

    if (changeCustomSelectedActors) {
      changeCustomSelectedActors(currentTaskCode, selected);
    }

    this.closeModal();
  };

  getRowSelection(selectedRowKeys: string[]) {
    return {
      selectedRowKeys,
      onChange: (keys: string[]) => {
        this.setState({ selectedRowKeys: keys });
      },
    };
  }

  renderModal() {
    const { intl, candidates, isCanBeSelected } = this.props;
    const { visible, selectedRowKeys } = this.state;


    return (
      <Modal
        visible={visible}
        title={intl.formatMessage({ id: "employees" })}
        onOk={this.handleOk}
        onCancel={this.closeModal}
        width={500}
        okButtonProps={{ disabled: !isCanBeSelected }}
        cancelButtonProps={{ disabled: false }}
      >
        <Table
          dataSource={candidates || []}
          rowKey={record => record.id}
          pagination={false}
          rowSelection={
            isCanBeSelected
              ? this.getRowSelection(selectedRowKeys)
              : undefined
          }
          columns={[
            {
              title: intl.formatMessage({ id: "beneficiary.employeeName" }),
              dataIndex: "fullName",
              key: "fullName",
            },
          ]}
        />
      </Modal>
    );
  }


  getCandidatesCard(candidates: TsadvUser[] | null) {
    if (!candidates || candidates.length === 0) return "";
    else if (candidates.length === 1) {
      return <div className="break-words">{candidates[0].fullName}</div>;
    } else {
      const minValue = `${candidates[0].fullName} +${candidates.length - 1}`;
      return (
        <a onClickCapture={this.openModal} key="modal" className={"flex gap-2 items-center"}>
          {minValue} {this.props.isCanBeSelected && <Icon type="edit" style={{ marginLeft: 4 }} />}
        </a>
      );
    }
  }

  render() {
    const candidates = this.props.candidates
      ? Array.from(this.props.candidates)
      : null;

    return (
      <>
        {this.getCandidatesCard(candidates)}
        {this.renderModal()}
      </>
    );
  }
}

export default withRouter(injectIntl(Candidate));
